var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editor
    ? _c(
        "bubble-menu",
        {
          ref: "refRichTextBubbleMenu",
          attrs: {
            editor: _vm.editorBubbleMenu,
            tippyOptions: _vm.getTippyOptions
          }
        },
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "div",
            { key: index },
            [
              option === "SellsyAI"
                ? _c("SellsyAIMenu", {
                    attrs: {
                      editor: _vm.editorBubbleMenu,
                      option: option,
                      disabled: _vm.disabled,
                      typeRichText: _vm.typeRichText,
                      hash: _vm.hash,
                      source: "bubblemenu"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }